module.exports = __webpack_public_path__ + "static/img/carac2.632ba834.jpg";